/* eslint-disable @typescript-eslint/no-unused-vars */
import Button from 'components/base/Button';
import DatePicker from 'components/base/DatePicker';
// import ReactSelect from 'components/base/ReactSelect';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { SITE_ENDPOINT } from 'Constant';
import { jobBreadcrumbItems } from 'data/commonData';
import { JobClient, ContactPerson } from 'data/users';
import { ChangeEvent, FormEvent, useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { GET_CUSTOMERS_QUERY, GET_COMPANY_REPS } from 'services/api/customer';
import { GET_EMPLOYEES_QUERY } from 'services/api/employee';
import { GET_JOB_QUERY, UPDATE_JOB } from 'services/api/job';
import { GET_JOBSTAGE_QUERY, JobStage } from 'services/api/jobStage';
import { GET_JOBTYPE_QUERY, JobType } from 'services/api/jobTypes';
import { GET_LOCATION_QUERY, Location } from 'services/api/location';
import { GET_RIGS_QUERY, RigResponse } from 'services/api/rigs';
import { toast } from 'react-hot-toast';
import { JOB_STAGES, STAGE_MAP } from 'constants/jobStage';

export enum DestinationType {
  International = 'International',
  Domestic = 'Domestic'
}
export class FormData {
  title!: string;
  well!: string;
  destinationType!: DestinationType;
  departureDate!: string | number | string[] | undefined;
  returnDate!: string | number | string[] | undefined;
  expectedEquipmentShipDate!: string | number | string[] | undefined;
  leavingFrom!: string;
  // remark!: string;
  description!: string;
  rig!: IndexKey;
  jobType!: IndexKey;
  location!: IndexKey;
  jobStage!: IndexKey;
  customer!: IndexKey;
  // assignedTo!: IndexKey[];
  supervisor!: IndexKey[];
  customerRepresentative!: IndexKey;
  jobNumber!: string;
  comment?: string;
}
export class IndexKey {
  _id!: string;
}

/**
 * Safely extracts an entity id regardless of whether the backend serialized it
 * as `_id`, `id`, or returned a bare id string. The job detail endpoint
 * populates nested objects (rig, jobType, location, jobStage, customer) with
 * `id`, while the dropdown list endpoints may use either `id` or `_id`.
 */
const getId = (value: unknown): string => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  const obj = value as { _id?: string; id?: string };
  return obj._id || obj.id || '';
};

const ObjectField = [
  'supervisor',
  'location',
  'customerRepresentative',
  'jobStage',
  'jobType',
  'rig',
  'customer'
];

const EditProject: React.FC = () => {
  const [validated, setValidated] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [formData, setFormData] = useState<FormData>(new FormData());
  const [validationMessages, setValidationMessages] = useState<
    Record<string, string>
  >({});
  const [returnDate, setReturnDate] = useState<Date | null>(null);
  const [comment, setComment] = useState<string>('');
  const [customerReps, setCustomerReps] = useState<ContactPerson[]>([]);

  const { id: jobId } = useParams<{ id: string }>();

  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const {
    data: job,
    isSuccess,
    isError
  } = useQuery(['getJobs', jobId], () =>
    jobId ? GET_JOB_QUERY(jobId) : Promise.reject('No id provided')
  );
  const editJobMutation = useMutation('updateJob', UPDATE_JOB, {
    onSuccess: () => {
      setIsLoading(false);
      queryClient.invalidateQueries('getJobs');
      navigate(`/${SITE_ENDPOINT.HOME}`);
    },
    onError: (error: any) => {
      setIsLoading(false);
      console.log(error);
    }
  });

  useEffect(() => {
    if (isSuccess && job.data) {
      setFormData(job.data as unknown as FormData);

      if (job.data.returnDate) {
        setReturnDate(new Date(job.data.returnDate));
      }

      if (job.data.comments && typeof job.data.comments === 'string') {
        setComment(job.data.comments);
      }
    }
  }, [isSuccess, job]);

  const handleEditJob = async (e: FormEvent) => {
    try {
      e.preventDefault();
      const form = e.currentTarget as HTMLFormElement;
      if (!form.checkValidity()) {
        setValidated(true);
        return;
      }

      // if (isEquipmentReturnedStage() && !returnDate) {
      //   toast.error('Please select a return date for equipment returned stage');
      //   return;
      // }

      setIsLoading(true);

      const formDataToSubmit: any = {
        ...formData
      };

      // if (isEquipmentReturnedStage()) {
      //   if (returnDate) {
      //     formDataToSubmit.returnDate = returnDate.toISOString();
      //   }
      //   if (comment) {
      //     formDataToSubmit.comment = comment;
      //   }
      // }

      await editJobMutation.mutateAsync({
        formData: formDataToSubmit,
        jobId: String(jobId)
      });
      toast.success('Job updated successfully');
    } catch (error: any) {
      console.error('Error editing job:', error);
      toast.error(error.response.data.messages || 'Failed to edit job');
    }
  };

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;

    if (!ObjectField.includes(name)) {
      setFormData(prevData => ({
        ...prevData,
        [name]: value
      }));
    } else {
      const fieldName = name as keyof FormData;

      if (fieldName === 'supervisor') {
        setFormData(prevData => ({
          ...prevData,
          [fieldName]: [{ _id: value }]
        }));
      } else {
        setFormData(prevData => ({
          ...prevData,
          [fieldName]: { _id: value }
        }));
      }
    }

    setValidationMessages(prevMessages => ({
      ...prevMessages,
      [name]: ''
    }));
  };

  const handleDateChange = (value: Date, name: string) => {
    setFormData(prevData => ({
      ...prevData,
      [name]: new Date(value)
    }));
    setValidationMessages(prevMessages => ({
      ...prevMessages,
      [name]: ''
    }));
  };
  const { data: customers } = useQuery('getCustomers', GET_CUSTOMERS_QUERY, {
    staleTime: 3 * 60 * 60 * 1000
  });
  const { data: employees } = useQuery('getEmployees', GET_EMPLOYEES_QUERY, {
    staleTime: 3 * 60 * 60 * 1000
  });

  const { data: rigs } = useQuery('getRigs', GET_RIGS_QUERY, {
    staleTime: 3 * 60 * 60 * 1000
  });

  const { data: jobTypes } = useQuery('getJobTypes', GET_JOBTYPE_QUERY, {
    staleTime: 3 * 60 * 60 * 1000
  });

  const { data: jobStages } = useQuery('getJobStages', GET_JOBSTAGE_QUERY, {
    staleTime: 3 * 60 * 60 * 1000
  });

  const { data: locations } = useQuery('getLocations', GET_LOCATION_QUERY, {
    staleTime: 3 * 60 * 60 * 1000
  });

  const customerId = getId(formData.customer);
  const { data: customerRepsData, isLoading: isLoadingCustomerReps } = useQuery(
    ['getCustomerReps', customerId],
    () => GET_COMPANY_REPS(customerId),
    {
      enabled: !!customerId,
      staleTime: 3 * 60 * 60 * 1000
    }
  );

  useEffect(() => {
    if (customerRepsData?.data) {
      setCustomerReps(customerRepsData.data || []);
    } else {
      setCustomerReps([]);
    }
  }, [customerRepsData]);

  const formCustomerRep = () => {
    return (
      <Form.Select
        name="customerRepresentative"
        value={getId(formData.customerRepresentative)}
        onChange={handleInputChange}
        required
        isInvalid={!!validationMessages.customerRepresentative}
      >
        <option>Select Contact Person</option>
        {isLoadingCustomerReps ? (
          <option value="">Loading...</option>
        ) : (
          customerReps.map(rep => (
            <option key={getId(rep)} value={getId(rep)}>
              {`${rep.firstName || ''} ${rep.lastName || ''}`}
            </option>
          ))
        )}
      </Form.Select>
    );
  };

  const isEquipmentReturnedStage = () => {
    if (!jobStages?.data || !getId(formData.jobStage)) return false;

    const selectedJobStage = jobStages.data.find(
      (stage: JobStage) => getId(stage) === getId(formData.jobStage)
    );

    if (!selectedJobStage) return false;

    return (
      selectedJobStage.name.toLowerCase() === JOB_STAGES.EQUIPMENT_RETURNED ||
      selectedJobStage.name.toLowerCase() === JOB_STAGES.EQUIPMENT_RETURN ||
      selectedJobStage.name.toLowerCase() ===
        STAGE_MAP['Equipment Returned'].toLowerCase()
    );
  };

  // const handleReturnDateChange = (date: Date) => {
  //   setReturnDate(date);
  // };

  // const handleCommentChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
  //   setComment(e.target.value);
  // };

  return (
    <div>
      <PageBreadcrumb items={jobBreadcrumbItems} />
      <h2 className="mb-4">Edit a Job</h2>
      <Row>
        <Col xs={12} xl={12}>
          <Form noValidate validated={validated} onSubmit={handleEditJob}>
            <Row className="g-2">
              <Col sm={6} md={8}>
                <Form.Group controlId="floatingInputGrid">
                  <Form.Label className="mb-2">Job title</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Job title"
                    onChange={handleInputChange}
                    value={formData.title}
                    required
                    name="title"
                    isInvalid={!!validationMessages.title}
                  />
                  <Form.Control.Feedback type="invalid">
                    {validationMessages.title || 'Please enter a title.'}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col sm={6} md={4}>
                <Form.Group controlId="floatingInputWell">
                  <Form.Label>
                    <strong
                      className="text-danger"
                      style={{ fontSize: '17px' }}
                    >
                      *
                    </strong>{' '}
                    Well
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Well Name"
                    name="well"
                    value={formData.well}
                    onChange={handleInputChange}
                    required
                    isInvalid={validated && !formData.well}
                  />
                  <Form.Control.Feedback type="invalid">
                    {validationMessages.well || 'Please enter a well.'}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col sm={6} md={8}>
                <Form.Group controlId="floatingSelectTeam">
                  <Form.Label>
                    <strong
                      className="text-danger"
                      style={{ fontSize: '17px' }}
                    >
                      *
                    </strong>{' '}
                    Destination Type
                  </Form.Label>
                  <Form.Select
                    name="destinationType"
                    value={formData.destinationType}
                    onChange={handleInputChange}
                    required
                    isInvalid={!!validationMessages.destinationType}
                  >
                    <option>Select Destination Type</option>
                    <option value="Domestic">Domestic</option>
                    <option value="International">International</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {validationMessages.destinationType ||
                      'Please select a destination type.'}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col sm={6} md={4}>
                <Form.Group controlId="floatingSelectAdmin">
                  <Form.Label>
                    <strong
                      className="text-danger"
                      style={{ fontSize: '17px' }}
                    >
                      *
                    </strong>{' '}
                    Project Lead
                  </Form.Label>
                  <Form.Select
                    name="supervisor"
                    value={getId(formData?.supervisor?.[0])}
                    onChange={handleInputChange}
                    required
                    isInvalid={validated && !getId(formData.supervisor?.[0])}
                  >
                    <option>Select Supervisor</option>
                    {employees?.data
                      .filter(employee => employee.isAdmin)
                      .map(admin => (
                        <option key={getId(admin)} value={getId(admin)}>
                          {admin?.firstName} {admin?.lastName}
                        </option>
                      ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {validationMessages.supervisor ||
                      'Please select a project lead'}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col sm={6} md={4}>
                <Form.Group controlId="departureDate">
                  <Form.Label>Expected Operator Departure Date</Form.Label>
                  <DatePicker
                    onChange={(value, currentDateString, self, data) => {
                      handleDateChange(value[0], self._input.name);
                    }}
                    name="departureDate"
                    value={formData.departureDate}
                    required
                    render={(_, ref) => {
                      return (
                        <Form.Control
                          type="text"
                          placeholder="Departure Date"
                          ref={ref}
                          name="departureDate"
                          value={formData.departureDate}
                          isInvalid={!!validationMessages.datePicker}
                          style={{ padding: '8px 45px' }}
                        />
                      );
                    }}
                  />
                  <Form.Control.Feedback type="invalid">
                    {validationMessages.datePicker || 'Please select a date.'}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col sm={6} md={4}>
                <Form.Group controlId="returnDate">
                  <Form.Label>Expected Operator Return Date</Form.Label>
                  <DatePicker
                    onChange={(value, currentDateString, self, data) =>
                      handleDateChange(value[0], self._input.name)
                    }
                    name="returnDate"
                    value={formData.returnDate}
                    required
                    id="returnDate"
                    render={(_, ref) => {
                      return (
                        <Form.Control
                          type="date"
                          placeholder="Return Date"
                          name="returnDate"
                          ref={ref}
                          id="returnDate"
                          value={formData.returnDate}
                          style={{ padding: '8px 45px' }}
                        />
                      );
                    }}
                  />
                </Form.Group>
              </Col>
              <Col sm={6} md={4}>
                <Form.Group controlId="expectedEquipmentShipDate">
                  <Form.Label>
                    Expected Equipment Ship Date
                    <strong
                      style={{ fontSize: '17px' }}
                      className="text-danger"
                    >
                      *
                    </strong>
                  </Form.Label>
                  <DatePicker
                    onChange={(value, currentDateString, self, _data) =>
                      handleDateChange(value[0], self._input.name)
                    }
                    name="expectedEquipmentShipDate"
                    value={formData.expectedEquipmentShipDate}
                    id="ExpectedEquipmentShipDate"
                    required
                    render={(_, ref) => {
                      return (
                        <Form.Control
                          type="date"
                          placeholder="Expected Equipment Ship Date"
                          ref={ref}
                          id="expectedEquipmentShipDate"
                          name="expectedEquipmentShipDate"
                          value={formData.expectedEquipmentShipDate}
                          required
                          isInvalid={
                            validated && !formData.expectedEquipmentShipDate
                          }
                          style={{ padding: '8px 45px' }}
                        />
                      );
                    }}
                  />
                  <Form.Control.Feedback type="invalid">
                    {validationMessages.expectedEquipmentShipDate ||
                      'Please enter an Equipment Ship Date.'}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              {/* Customers */}
              <Col md={6}>
                <Form.Group controlId="floatingSelectClient">
                  <Form.Label>
                    <strong
                      className="text-danger"
                      style={{ fontSize: '17px' }}
                    >
                      *
                    </strong>{' '}
                    Client
                  </Form.Label>
                  <Form.Select
                    name="customer"
                    value={getId(formData.customer)}
                    onChange={handleInputChange}
                    required
                    isInvalid={!!validationMessages.customer}
                  >
                    <option>Select client</option>
                    {customers?.data.map((customer: JobClient) => (
                      <option key={getId(customer)} value={getId(customer)}>
                        {customer.organizationName}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {validationMessages.customer || 'Please enter a customer.'}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              {/* Contact Person */}
              <Col md={6}>
                <Form.Group controlId="floatingSelectContactPerson">
                  <Form.Label>Contact Person</Form.Label>
                  {formCustomerRep()}
                  <Form.Control.Feedback type="invalid">
                    {validationMessages.customerRepresentative ||
                      'Please enter a customer.'}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              {/* Rig */}
              <Col md={6}>
                <Form.Group controlId="floatingSelectRig">
                  <Form.Label>Rig</Form.Label>
                  <Form.Select
                    name="rig"
                    value={getId(formData.rig)}
                    onChange={handleInputChange}
                    required
                    isInvalid={!!validationMessages.rig}
                  >
                    <option>Select Rig</option>
                    {rigs?.data
                      .sort((a, b) => a.name.localeCompare(b.name))
                      ?.map((rig: RigResponse) => (
                        <option key={getId(rig)} value={getId(rig)}>
                          {rig.name}
                        </option>
                      ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {validationMessages.rig || 'Please enter a rig.'}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              {/* {Add Job Type} */}
              <Col md={6}>
                <Form.Group controlId="floatingSelectJobType">
                  <Form.Label>
                    <strong
                      className="text-danger"
                      style={{ fontSize: '17px' }}
                    >
                      *
                    </strong>{' '}
                    Job Type
                  </Form.Label>
                  <Form.Select
                    name="jobType"
                    value={getId(formData.jobType)}
                    onChange={handleInputChange}
                    required
                    isInvalid={!!validationMessages.jobType}
                  >
                    <option>Select Type of Job</option>
                    {jobTypes?.data.map((jobType: JobType) => (
                      <option key={getId(jobType)} value={getId(jobType)}>
                        {jobType.name}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {validationMessages.jobType || 'Please select a Job Type.'}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              {/* {Add job Stage} */}
              <Col md={6}>
                <Form.Group controlId="floatingSelectJobStage">
                  <Form.Label>
                    <strong
                      className="text-danger"
                      style={{ fontSize: '17px' }}
                    >
                      *
                    </strong>{' '}
                    Job Stage
                  </Form.Label>
                  <Form.Select
                    name="jobStage"
                    value={getId(formData.jobStage)}
                    onChange={handleInputChange}
                    required
                    isInvalid={!!validationMessages.jobStage}
                  >
                    <option>Select Job Stage</option>
                    {jobStages?.data.map((jobStage: JobStage) => (
                      <option key={getId(jobStage)} value={getId(jobStage)}>
                        {jobStage.name}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {validationMessages.jobStage || 'Please select a Job type.'}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              {/* Conditional Return Date field for Equipment Returned stage */}
              {/* {isEquipmentReturnedStage() && (
                <Col md={6}>
                  <Form.Group controlId="equipmentReturnDate">
                    <Form.Label>
                      <strong
                        className="text-danger"
                        style={{ fontSize: '17px' }}
                      >
                        *
                      </strong>{' '}
                      Equipment Return Date
                    </Form.Label>
                    <DatePicker
                      onChange={value => handleReturnDateChange(value[0])}
                      name="equipmentReturnDate"
                      value={returnDate || undefined}
                      required
                      render={(_, ref) => {
                        return (
                          <Form.Control
                            type="text"
                            placeholder="Select return date"
                            ref={ref}
                            name="equipmentReturnDate"
                            value={
                              returnDate ? returnDate.toLocaleDateString() : ''
                            }
                            isInvalid={
                              isEquipmentReturnedStage() && !returnDate
                            }
                            style={{ padding: '8px 45px' }}
                          />
                        );
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please select a return date.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              )}

              {isEquipmentReturnedStage() && (
                <Col xs={12}>
                  <Form.Group controlId="equipmentReturnComments">
                    <Form.Label>Return Comments</Form.Label>
                    <Form.Control
                      as="textarea"
                      placeholder="Add comments about the equipment return"
                      style={{ height: '100px' }}
                      name="comment"
                      value={comment}
                      onChange={handleCommentChange}
                    />
                  </Form.Group>
                </Col>
              )} */}

              {/* {Add Location} */}
              <Col md={6}>
                <Form.Group controlId="floatingSelectLocation">
                  <Form.Label>
                    <strong
                      className="text-danger"
                      style={{ fontSize: '17px' }}
                    >
                      *
                    </strong>{' '}
                    Location
                  </Form.Label>
                  <Form.Select
                    name="location"
                    value={getId(formData.location)}
                    onChange={handleInputChange}
                    required
                    isInvalid={!!validationMessages.location}
                  >
                    <option>Select Location</option>
                    {locations?.data.map((location: Location) => (
                      <option key={getId(location)} value={getId(location)}>
                        {location.location}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {validationMessages.location || 'Please select a Location.'}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              {/* Location */}
              <Col md={6}>
                <Form.Group controlId="floatingInputLeavingFrom">
                  <Form.Label>Leaving From</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Leaving From"
                    name="leavingFrom"
                    value={formData.leavingFrom}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="floatingInputJobNumber">
                  <Form.Label>
                    <strong
                      className="text-danger"
                      style={{ fontSize: '17px' }}
                    >
                      *
                    </strong>{' '}
                    Job Number
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="0001 JOBS"
                    name="jobNumber"
                    value={formData.jobNumber}
                    onChange={handleInputChange}
                    required
                    isInvalid={validated && !formData.jobNumber}
                  />
                  <Form.Control.Feedback type="invalid">
                    {validationMessages.jobNumber || 'Job Number is required'}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12}>
                <Form.Group controlId="floatingProjectOverview">
                  <Form.Label>Job Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    placeholder="Enter job description here"
                    style={{ height: '100px' }}
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col xs={12}>
                <div
                  style={
                    isLoading
                      ? {
                          transition: 'filter 0.5s ease',
                          filter: 'blur(5px);'
                        }
                      : undefined
                  }
                >
                  <div className="d-flex justify-content-end gap-3 my-5">
                    <Link to="/home">
                      <Button
                        disabled={isLoading}
                        variant="phoenix-primary"
                        className="px-5"
                      >
                        Cancel
                      </Button>
                    </Link>
                    <Button
                      variant="primary"
                      className="px-5 px-sm-15"
                      onClick={handleEditJob}
                      disabled={isLoading}
                    >
                      {isLoading ? 'Updating...' : 'Update Job'}
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default EditProject;
